import { useSelector } from "react-redux";
import { useCallback, useMemo } from "react";
import { isProd } from "@cores/enviromentExtension";
import { ROLE_PERMISSIONS } from "@constants";

const UseCheckPermission = ({ scope, domain }) => {
    const stage = useSelector(({ stage }) => stage);
    const project = useSelector(({ project }) => project);

    const myProjectPermissions = useSelector(({ roleManagementV2 }) => roleManagementV2?.projectPermissions?.data);
    const mySpacePermissions = useSelector(({ roleManagementV2 }) => roleManagementV2?.spacePermissions?.data);
    const isSpaceAdmin = useSelector(({ stage }) => stage?.user?.isSpaceAdmin);
    const isProjectAdmin = useSelector(({ stage }) => stage?.user?.projects.find((p) => p.id === project.id)?.isAdmin);

    const myPermissions = useMemo(
        () => (scope === "Project" ? myProjectPermissions : mySpacePermissions),
        [myProjectPermissions, mySpacePermissions],
    );

    const domainPermissions = useMemo(() => {
        const result = {};
        const permissions = ROLE_PERMISSIONS[domain];

        permissions?.forEach((permission) => {
            const permissionKey = permission.toUpperCase();

            if (!myPermissions) {
                result[permissionKey] = true;
                return;
            }
            if (isSpaceAdmin || isProjectAdmin) {
                result[permissionKey] = true;
                return;
            }
            if (!scope || !domain) {
                result[permissionKey] = false;
                return;
            }

            const searchString = `${scope}:${domain}:${permission}`;
            const isPermissionFound = myPermissions.some(
                (p) => p.id === searchString || p.includes.includes(searchString),
            );
            result[permissionKey] = isPermissionFound;
        });

        return result;
    }, [myPermissions]);

    return domainPermissions;
};

export default UseCheckPermission;
